import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-place-image.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import VelavuButton from "../../../../elements/velavu-button";
import { VelavuFloor } from "velavu-js-api";
import VelavuSlider from "../../../../elements/velavu-slider";
import VelavuSelect from "../../../../elements/velavu-select";
import FloorInputPlaceImage from "../floor-input/floor-input-place-image";

export interface FloorCreatePlaceImageProps {
	onClose?: () => void;
	onConfirm?: () => void;

	imageOpacity: number;
	onChangeImageOpacity: (opacity: number) => void;

	availableFloors: VelavuFloor[];
	referenceFloorID: string | null;
	onSelectReferenceFloor?: (floorID: string | null) => void;
}

export default function FloorCreatePlaceImage(
	props: FloorCreatePlaceImageProps,
) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.place_floor_plan")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<FloorInputPlaceImage
					imageOpacity={props.imageOpacity}
					onChangeImageOpacity={props.onChangeImageOpacity}
					availableFloors={props.availableFloors}
					referenceFloorID={props.referenceFloorID}
					onSelectReferenceFloor={props.onSelectReferenceFloor}
				/>
			</div>

			<div className={styles.content}>
				<VelavuButton
					label={t("common.confirm_placement")}
					onClick={props.onConfirm}
					fullWidth
				/>
			</div>
		</PinnedList>
	);
}
